import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.addEventListener('HomeFold', (e) => {
            const { target, way } = e.detail;
            const targetCondition = this.el;
            if (target === targetCondition) {
                if (way === 'enter') {
                        document.querySelector('html').classList.add('is-over-home-fold');
                } else if (way === 'leave') {
                    document.querySelector('html').classList.remove('is-over-home-fold');
                }
            }
        });
    }

    destroy() {
        window.removeEventListener('HomeFold', (e) => {
            const { target, way } = e.detail;
            const targetCondition = this.el;
            if (target === targetCondition) {
                if (way === 'enter') {
                        document.querySelector('html').classList.add('is-over-home-fold');
                } else if (way === 'leave') {
                    document.querySelector('html').classList.remove('is-over-home-fold');
                }
            }
        });
        document.querySelector('html').classList.remove('is-over-home-fold');
    }
}
